import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { RadioButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

export const StyledVisibilityModalTitle = styled(Text)`
    ${mixins.setFontVariant("h5_2", colorsPalettes.carbon[500])};
`;

export const StyledRadioButton = styled(RadioButton)`
    padding: 0;
    align-items: flex-start;
`;
